import React from 'react';
import {observer} from 'mobx-react';
import {TimeTrackingSubnav} from 'main/containers/time_tracking';
import MyTimesheetContainerWithState from 'main/containers/time_tracking/components/my_timesheet/components/MyTimesheetContainerWithState';

const MyTimesheetContainer = observer(({scope}) => {
  return (
    <div>
      <TimeTrackingSubnav scope={scope} />
      <MyTimesheetContainerWithState/>
    </div>
  );
});

export default MyTimesheetContainer;
